import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import type { Session } from '@supabase/supabase-js'
import { supabase } from './supabase.ts'

const SessionCtx = createContext<{ session: Session | null; pret: boolean }>({ session: null, pret: false })

export function FournisseurSession({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session | null>(null)
  const [pret, setPret] = useState(!supabase)
  useEffect(() => {
    if (!supabase) return
    supabase.auth.getSession().then(({ data }) => { setSession(data.session); setPret(true) })
    const { data } = supabase.auth.onAuthStateChange((_e, s) => setSession(s))
    return () => data.subscription.unsubscribe()
  }, [])
  return <SessionCtx.Provider value={{ session, pret }}>{children}</SessionCtx.Provider>
}

export const useSession = () => useContext(SessionCtx)

/**
 * Connexion par email + mot de passe (Kevin 2026-09-28 : les manageuses ne recoivent pas le
 * lien par mail, le projet n a pas de serveur d envoi). Le lien magique reste en secours,
 * pour les comptes de l equipe technique. Comptes crees par la direction seulement.
 */
export function Connexion() {
  const [email, setEmail] = useState('')
  const [mdp, setMdp] = useState('')
  const [etat, setEtat] = useState<'saisie' | 'envoi' | 'envoye' | 'erreur'>('saisie')
  const [erreur, setErreur] = useState('')

  async function connecter(e: React.FormEvent) {
    e.preventDefault()
    if (!supabase) return
    setEtat('envoi')
    const { error } = await supabase.auth.signInWithPassword({ email, password: mdp })
    if (error) { setErreur(/invalid login credentials/i.test(error.message) ? 'Email ou mot de passe incorrect.' : error.message); setEtat('erreur') }
    else setEtat('saisie')
  }

  async function lien() {
    if (!supabase || !email) return
    setEtat('envoi')
    const { error } = await supabase.auth.signInWithOtp({ email, options: { emailRedirectTo: window.location.origin, shouldCreateUser: false } })
    if (error) { setErreur(/signups? not allowed|not found/i.test(error.message) ? 'Aucun compte pour cet email : demande à la direction de te créer un accès.' : error.message); setEtat('erreur') } else setEtat('envoye')
  }

  return (
    <div className="connexion">
      <div className="connexion__carte">
        <div className="coque__marque">MUSE</div>
        {etat === 'envoye' ? (
          <p>Lien envoyé à <strong>{email}</strong>. Ouvre-le sur cet appareil.</p>
        ) : (
          <form onSubmit={connecter}>
            <label htmlFor="email">Email</label>
            <input id="email" type="email" required autoFocus autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} />
            <label htmlFor="mdp">Mot de passe</label>
            <input id="mdp" type="password" required autoComplete="current-password" value={mdp} onChange={(e) => setMdp(e.target.value)} />
            <button disabled={etat === 'envoi' || !email || !mdp}>{etat === 'envoi' ? 'Connexion…' : 'Se connecter'}</button>
            {etat === 'erreur' && <p className="connexion__erreur">{erreur}</p>}
            <button type="button" className="connexion__lien" disabled={etat === 'envoi' || !email} onClick={lien}>Recevoir plutôt un lien par mail</button>
          </form>
        )}
      </div>
    </div>
  )
}
